// extracted by mini-css-extract-plugin
export var box = "_63-1";
export var checked = "_63-2";
export var descriptionSpacer = "_63-9";
export var disabled = "_63-3";
export var icon = "_63-6";
export var input = "_63-0";
export var labelSpacer = "_63-8";
export var medium = "_63-5";
export var small = "_63-4";
export var text = "_63-7";